module.exports = __webpack_public_path__ + "static/media/faq-guestlist.c93e911d.svg";